import Location from './Location';

export default class Discard extends Location {

	constructor (master) {

		super(master, "discard");
	}
}